import API_CONFIG from '../config/api.config';

export function visitorMediaUrl(kind, filename) {
  if (!filename || filename === 'profile.png') {
    return '';
  }
  if (filename.startsWith('http')) {
    return filename;
  }
  return `${API_CONFIG.UPLOADS_BASE}/${kind}/${filename}`;
}

export function visitorMediaFallbackUrl(kind, filename) {
  if (!filename || filename.startsWith('http')) {
    return '';
  }
  return `${API_CONFIG.LEGACY_UPLOADS_BASE}/${kind}/${filename}`;
}
